import usePostApi from '@/hooks/usePostApi';
import { useTranslations } from '@/lib/i18n';
import { Button, TextInput } from '@mantine/core';
import { useForm, zodResolver } from '@mantine/form';

import { z } from 'zod';

const initialFormValues = {
  email: ''
};

const formSchema = z.object({
  email: z.string().email({ message: 'login_view.enter_your_email' })
});

type FormSchemaType = z.infer<typeof formSchema>;

interface IRequestCodeProps {
  onReceived: (username: string) => void;
}

function RequestCodeForm(props: IRequestCodeProps) {
  const t = useTranslations();
  const form = useForm<FormSchemaType>({
    mode: 'uncontrolled',
    initialValues: initialFormValues,
    validate: zodResolver(formSchema)
  });

  const requestApi = usePostApi<{ email: string }, { requested_at: number }>({
    resourceUrl: '/v1/auth/login_request'
  });

  const handleFormSubmit = form.onSubmit(async (values) => {
    const response = await requestApi.mutateAsync({ email: values.email });

    if (response.data.requested_at) {
      props.onReceived(values.email);
    }
  });

  return (
    <form onSubmit={handleFormSubmit}>
      <TextInput
        required
        label={t('login_view.email')}
        placeholder={t('login_view.email')}
        {...form.getInputProps('email')}
        error={t((form.errors.email as string) || '')}
      />
      <Button type="submit" disabled={requestApi.isPending} loading={requestApi.isPending} fullWidth mt="xl">
        {t('login_view.request_login_code')}
      </Button>
    </form>
  );
}

export default RequestCodeForm;
